// #region exportStingToTxtFile
export function exportStingToTxtFile(
  content: string,
  fileName: string = `export-${Date.now()}`
): boolean {
  try {
    // Create a Blob from the content
    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    // Create a link element to download the file
    const link = document.createElement("a");
    link.href = url;
    link.download = `${fileName}.txt`;

    // Append the link to the body and trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Failed to export content:", error);
    return false;
  }
}

// #endregion exportStingToTxtFile
